"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoesStateRequireServiceFeesIntegratedIntoPricing = exports.DoesStateRequireStatuarySurchargeNotice = exports.checkFlexPayEligibilityAnnotated = exports.FlexPayErrors = exports.IsPaymentEligibleForFees = exports.IsFlexPayAvailable = void 0;
const annotater_1 = require("../annotater");
const usStatesAndTerritories_1 = require("../locations/usStatesAndTerritories");
const Rules = require("./rules");
const cardType_1 = require("./cardType");
function IsFlexPayAvailable(clinicInformation) {
    const stateKey = (0, usStatesAndTerritories_1.getUnitedStatesStateOrTerritoryKeyFromString)(clinicInformation.state);
    return Rules.StateIsEligibleForFlexPay(stateKey);
}
exports.IsFlexPayAvailable = IsFlexPayAvailable;
function IsPaymentEligibleForFees(paymentInformation) {
    const cardType = (0, cardType_1.toCardType)(paymentInformation.cardType);
    return Rules.PaymentMethodEligibleForFees(cardType);
}
exports.IsPaymentEligibleForFees = IsPaymentEligibleForFees;
// A list of errors types
var FlexPayErrors;
(function (FlexPayErrors) {
    FlexPayErrors["CannotCollectFeesOnPaymentMethod"] = "Cannot collect fees on this payment method";
    FlexPayErrors["StateIsNotEligibleForFlexPay"] = "State is not eligible for Flex Pay";
    FlexPayErrors["ClientFeesExceedsClinicFees"] = "Client fees cannot exceed Clinic fees";
    FlexPayErrors["ServiceFeePercentageExceedsNetworkMaximum"] = "Service fee percentage exceeds network maximum";
})(FlexPayErrors = exports.FlexPayErrors || (exports.FlexPayErrors = {}));
function checkFlexPayEligibilityAnnotated(clinicInformation, paymentInformation) {
    const ant = new annotater_1.Annotater();
    const stateKey = (0, usStatesAndTerritories_1.getUnitedStatesStateOrTerritoryKeyFromString)(clinicInformation.state);
    const cardType = (0, cardType_1.toCardType)(paymentInformation.cardType);
    ant.setMetadata({
        method: checkFlexPayEligibilityAnnotated.name,
        clinicInformation,
        paymentInformation,
        stateKey,
        cardType,
    });
    if (!Rules.StateIsEligibleForFlexPay(stateKey)) {
        ant.fail(FlexPayErrors.StateIsNotEligibleForFlexPay);
    }
    if (!Rules.PaymentMethodEligibleForFees(cardType)) {
        ant.fail(FlexPayErrors.CannotCollectFeesOnPaymentMethod);
    }
    if (!Rules.ClientFeesCannotExceedClinicFees(clinicInformation.clientServiceFeePercentage, clinicInformation.clinicServiceFeePercentage)) {
        ant.fail(FlexPayErrors.ClientFeesExceedsClinicFees);
    }
    if (!Rules.ServiceFeePercentageCannotExceedNetworkMaximum(stateKey, clinicInformation.clientServiceFeePercentage, clinicInformation.clinicServiceFeePercentage)) {
        ant.fail(FlexPayErrors.ServiceFeePercentageExceedsNetworkMaximum);
    }
    return ant;
}
exports.checkFlexPayEligibilityAnnotated = checkFlexPayEligibilityAnnotated;
function DoesStateRequireStatuarySurchargeNotice(clinicInformation) {
    const state = (0, usStatesAndTerritories_1.getUnitedStatesStateOrTerritoryKeyFromString)(clinicInformation.state);
    return Rules.StateRequireStatuarySurchargeNotice(state);
}
exports.DoesStateRequireStatuarySurchargeNotice = DoesStateRequireStatuarySurchargeNotice;
function DoesStateRequireServiceFeesIntegratedIntoPricing(clinicInformation) {
    const state = (0, usStatesAndTerritories_1.getUnitedStatesStateOrTerritoryKeyFromString)(clinicInformation.state);
    return Rules.StateRequiresServiceFeesIntegratedIntoPricing(state);
}
exports.DoesStateRequireServiceFeesIntegratedIntoPricing = DoesStateRequireServiceFeesIntegratedIntoPricing;
//# sourceMappingURL=index.js.map